import(/* webpackMode: "eager" */ "/codebuild/output/src3109319297/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/global-error.tsx");
